import { observable } from 'mobx';

// 商品 Store，与新品体验 product 模块保持独立。
export class GoodsStore {
    @observable namespace = 'goods';

    @observable goodsData = null;
    @observable goodsDetailLoading = false;
    @observable goodsDetailError = null;
    @observable goodsDetailErrorCode = null;
    @observable goodsList = [];
    @observable goodsListTotal = 0;
    @observable goodsListServerAt = null;
    @observable goodsListLoading = false;
    @observable goodsListError = null;
    @observable goodsExchangeLoading = false;
    @observable goodsExchangeError = null;
    @observable goodsLotteryLoading = false;
    @observable goodsLotteryError = null;
    @observable addressList = [];
    @observable defaultAddress = null;
    @observable addressLoading = false;
    @observable addressLoaded = false;
    @observable addressError = null;

    constructor(initData = {}) {
        this.goodsData = initData.goodsData || null;
        this.goodsDetailErrorCode = initData.goodsDetailErrorCode ?? null;
        this.goodsList = initData.goodsList || [];
        this.goodsListTotal = initData.goodsListTotal || 0;
        this.goodsListServerAt = initData.goodsListServerAt || null;
        this.addressList = initData.addressList || [];
        this.defaultAddress = initData.defaultAddress || null;
    }
}
